import React, { useEffect, useRef } from "react";
import { Accordion } from "react-bootstrap";
import "../../styles/entertainment.css";
import "../../styles/animatica.css";

const HkianimaticaFaqs = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add("an-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      id="faq"
      ref={sectionRef}
      className="an-section py-5"
    >
      <div className="an-glow an-glow-left" />
      <div className="container position-relative">
        <span className="an-reveal an-reveal-d1 an-eyebrow justify-content-center w-100">
          Got Questions?
        </span>
        <h2 className="an-reveal an-reveal-d2 text-center fw-bold fs_44 ff_s an-title-gradient d-block">
          FAQ&rsquo;s
        </h2>
        <div className="an-reveal an-divider" />
        <div className="row justify-content-center">
          <div className="col-md-10 faq an-reveal an-reveal-d2">
            <Accordion className="an-accordion mt-4">
              <Accordion.Item
                className="backdrop-blur-md bg-white/[0.03] border border-white/10 rounded-2 mt-3"
                eventKey="0"
              >
                <Accordion.Header className="rounded-2">
                  <h3 className="mb-0 fs_18 fw-semibold ff_n" style={{ color: "#f8fafc" }}>
                    Who Can Buy an ICASA Franchise?
                  </h3>
                </Accordion.Header>
                <Accordion.Body className="pt-0 text_justify" style={{ color: "rgba(248, 250, 252, 0.68)" }}>
                  The ICASA franchise is perfect for media
                  organizations, educational institutions, or media agencies
                  looking to dominate India’s rapidly evolving creative market.
                  If you’re ready to make it big, this is your opportunity!
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                className="backdrop-blur-md bg-white/[0.03] border border-white/10 rounded-2 mt-3"
                eventKey="1"
              >
                <Accordion.Header className="rounded-2">
                  <h3 className="mb-0 fs_18 fw-semibold ff_n" style={{ color: "#f8fafc" }}>
                    When Does the First Batch Start?
                  </h3>
                </Accordion.Header>
                <Accordion.Body className="pt-0 text_justify" style={{ color: "rgba(248, 250, 252, 0.68)" }}>
                  The first batch of ICASA students will commence their
                  journey in June 2025. Be part of this revolutionary launch and
                  start shaping the future of India’s creative minds!
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                className="backdrop-blur-md bg-white/[0.03] border border-white/10 rounded-2 mt-3"
                eventKey="2"
              >
                <Accordion.Header className="rounded-2">
                  <h3 className="mb-0 fs_18 fw-semibold ff_n" style={{ color: "#f8fafc" }}>
                    What Is the Franchise Fee?
                  </h3>
                </Accordion.Header>
                <Accordion.Body className="pt-0 text_justify" style={{ color: "rgba(248, 250, 252, 0.68)" }}>
                  There’s no franchise fee! Simply choose the courses you wish
                  to offer, and our expert team will assist you in setting up
                  your ICASA Centre of Excellence.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                className="backdrop-blur-md bg-white/[0.03] border border-white/10 rounded-2 mt-3 "
                eventKey="3"
              >
                <Accordion.Header className="rounded-2">
                  <h3 className="mb-0 fs_18 fw-semibold ff_n" style={{ color: "#f8fafc" }}>
                    Which Courses Are Offered by ICASA?
                  </h3>
                </Accordion.Header>
                <Accordion.Body className="pt-0 text_justify" style={{ color: "rgba(248, 250, 252, 0.68)" }}>
                  For detailed information about our wide range of courses,
                  reach out to our support email or fill out the interest form.
                  Our team will guide you through the options tailored to your
                  needs.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                className="backdrop-blur-md bg-white/[0.03] border border-white/10 rounded-2 mt-3"
                eventKey="4"
              >
                <Accordion.Header className="rounded-2">
                  <h3 className="mb-0 fs_18 fw-semibold ff_n" style={{ color: "#f8fafc" }}>
                    Where Can I Open an ICASA COE?
                  </h3>
                </Accordion.Header>
                <Accordion.Body className="pt-0 text_justify" style={{ color: "rgba(248, 250, 252, 0.68)" }}>
                  You can open an ICASA Centre of Excellence anywhere in
                  India with good connectivity and infrastructure. For detailed
                  prerequisites, fill out the interest form, and our team will
                  assist you.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HkianimaticaFaqs;
